import React, { useState, useEffect, useCallback } from "react";
import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Colors } from "../../../Styles/Colors";
import {
  CommonEditButton,
  CommonGridToolBarWithFilterText,
} from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";

export default function RoleAccess() {
  const navigate = useNavigate();
  const [roleData, setRoleData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [isErrorMsgText, setIsErrorMsgText] = useState("");
  const [successMsg, setSuccessMsg] = useState(false);
  const [successMsgText, setSuccessMsgText] = useState("");

  useEffect(() => {
    getRoleList();
  }, []);

  const errorMessage = (msg) => {
    setIsErrorMsg(true);
    setIsErrorMsgText(msg);
  };

  const msgClose = () => {
    setIsErrorMsg(false);
    setIsErrorMsgText("");
    setSuccessMsg(false);
    setSuccessMsgText("");
  };

  const getRoleList = useCallback(() => {
    try {
      setIsLoader(true);
      RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_ROLE_MASTER)
        .then((response) => {
          if (response?.data?.status === "success") {
            const data = response.data.data || [];
            setRoleData(
              Array.isArray(data) ? data.map((item, index) => ({ ...item, sno: index + 1 })) : []
            );
          }
          setIsLoader(false);
        })
        .catch((e) => {
          setIsLoader(false);
          errorMessage(e?.response?.data?.message || e?.message);
        });
    } catch (e) {
      setIsLoader(false);
      errorMessage(e.message);
    }
  }, []);

  const gridToolBar = () => (
    <Box>
      <CommonGridToolBarWithFilterText fromStore searchHolder="Search role code, role name..." />
    </Box>
  );

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex: 0.1,
      renderCell: ({ row }) => <Box>{row?.sno ?? "-"}</Box>,
    },
    {
      field: "role_code",
      headerName: "Role Code",
      flex: 0.2,
      renderCell: ({ row }) => <Box>{row?.role_code || "-"}</Box>,
    },
    {
      field: "role_name",
      headerName: "Role Name",
      flex: 0.6,
      renderCell: ({ row }) => <Box>{row?.role_name || "-"}</Box>,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.1,
      renderCell: ({ row }) => (
        <CommonEditButton
          size="1.5vw"
          onClick={() =>
            navigate(
              "/HistopathologySetting/UserConfiguration/RoleAccess/Add",
              {
                state: {
                  role_name: row.role_name || "",
                  role_code: row.role_code || null,
                  edit_id: row.id,
                  permission_access: row.permission_access || row.screen_access || [],
                },
              }
            )
          }
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        height: "79.5vh",
        width: "100%",
        backgroundColor: Colors.Background,
        padding: "0.5vw",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: "0.5vw",
        }}
      >
        <Button
          size="small"
          variant="contained"
          sx={{ textTransform: "capitalize" }}
          onClick={() => navigate("/HistopathologySetting/UserConfiguration/RoleAccess/Add")}
        >
          Add Role
        </Button>
      </Box>

      <Box
        sx={{
          height: "70vh",
          width: "100%",
          backgroundColor: "white",
          boxSizing: "border-box",
        }}
      >
        <DataGrid
          sx={{ width: "100%" }}
          rows={roleData}
          columns={columns}
          getRowId={(row) => row.id ?? row.sno}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 20, 30]}
          pagination
          headerHeight={40}
          rowHeight={40}
          density="standard"
          disableRowSelectionOnClick
          loading={isLoader}
          showToolbar
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: "",
          }}
          slots={{
            toolbar: gridToolBar,
            noRowsOverlay: () => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                No Records To Be Shown
              </Box>
            ),
          }}
        />
      </Box>

      {isErrorMsg && (
        <ToastMsg
          severity="error"
          msg={isErrorMsgText}
          msgPop={msgClose}
        />
      )}
      {successMsg && (
        <ToastMsg
          severity="success"
          msg={successMsgText}
          msgPop={msgClose}
        />
      )}
    </Box>
  );
}
